module.exports = __webpack_public_path__ + "img/tipology_mail_hdtool.55ab520c.png";